import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import HomeNew from "./views/HomeNew.vue";
// import About from "./views/About.vue";
import Root from "./views/Root.vue";
import Result from "./views/Result.vue";
import Profile from "./views/Profile.vue";
import Details from "./views/Details.vue";
import Favorites from "./views/Favorites.vue";
import Faq from "./views/Faq.vue";
import Rules from "./views/Rules.vue";
import i18n from "./i18n.js";
import store from "./store.js";
import News from "./views/News.vue";
import Admin from "./views/Admin.vue";
import NewAd from "./views/NewAd.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import Verification from "./views/Verification.vue";
import VerificationDisplay from "./views/VerificationDisplay.vue";
import Unsubscribe from "./views/Unsubscribe.vue";
import EditAd from "./views/EditAd3.vue";
import PageNotFound from "./views/PageNotFound.vue";
import Competition from "./views/Competition.vue";
import CompetitionEntry from "./views/CompetitionEntry.vue";
import CompetitionEntryEdit from "./views/CompetitionEntryEdit.vue";
import Competitions from "./views/Competitions.vue";
import CompetitionRankList from "./views/CompetitionRankList.vue";
import CompetitionRules from "./views/CompetitionRules.vue";
import CompetitionNoSchool from "./views/CompetitionNoSchool.vue";
import Franchise from "./views/Franchise.vue";
import { api } from "@/api";
import BuyersHome from "./views/home/BuyersHome.vue";
import SellersHome from "./views/home/SellersHome.vue";
import NewsDescriptionPage from "./views/NewsDescriptionPage.vue";
import RegisterPage from "./views/auth/RegisterPage.vue";
import RegisterPage1 from "./views/auth/children/RegisterPage1.vue";
import RegisterPage2 from "./views/auth/children/RegisterPage2.vue";
import RegisterPage3 from "./views/auth/children/RegisterPage3.vue";
import MyProfile from "@/components/profile/profile.vue";
import MyPurchases from "@/components/profile/myPurchases.vue";
import MySales from "@/components/profile/mySales.vue";
// import Sugestions from "@/components/profile/sugestions.vue";
import MyBuyers from "@/components/profile/myBuyers.vue";
import MySellers from "@/components/profile/mySellers.vue";
import Notifications from "@/components/profile/notificationsWrapper.vue";
import MessagesWrapper from "./components/profile/messagesWrapper.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      redirect: "/" + i18n.locale
    },
    {
      path: "/:lang",
      name: "Root",
      component: Root,
      children: [
        {
          path: "/:lang",
          name: "Home",
          component: HomeNew
        },
        {
          path: "/:lang/berza",
          name: "Berza",
          component: Home
        },
        {
          path: "/:lang/buyers",
          name: "Buyers",
          component: BuyersHome
        },
        {
          path: "/:lang/sellers",
          name: "Sellers",
          component: SellersHome
        },
        {
          path: "/:lang/not-found",
          name: "NotFound",
          component: PageNotFound
        },
        // {
        //   path: "/:lang/about",
        //   name: "About",
        //   component: About
        // },
        {
          path: "/:lang/result",
          name: "Result",
          component: Result
        },
        {
          path: "/:lang/details/:id",
          name: "Details",
          component: Details
        },
        {
          path: "/:lang/editAd/:id",
          name: "EditAd",
          meta: {
            sidRequired: true
          },
          component: EditAd
        },
        {
          path: "/:lang/favorites",
          name: "Favorites",
          meta: {
            sidRequired: true
          },
          component: Favorites
        },
        {
          path: "/:lang/admin",
          name: "Admin",
          meta: {
            adminRequired: true
          },
          component: Admin
        },
        {
          path: "/:lang/profile",
          name: "Profile",
          redirect: "/:lang/profile/my-sales",
          meta: {
            sidRequired: true
          },
          component: Profile,
          children: [
            {
              path: "/:lang/profile/my-profile",
              name: "MyProfile",
              component: MyProfile,
              meta: {
                sidRequired: true
              }
            },
            {
              path: "/:lang/profile/my-purchases",
              name: "MyPurchases",
              component: MyPurchases,
              meta: {
                sidRequired: true
              }
            },
            {
              path: "/:lang/profile/my-sales",
              name: "MySales",
              component: MySales,
              meta: {
                sidRequired: true
              }
            },
            // {
            //   path: "/:lang/profile/sugestions",
            //   name: "Sugestions",
            //   component: Sugestions,
            //   meta: {
            //     sidRequired: true
            //   }
            // },
            {
              path: "/:lang/profile/my-buyers",
              name: "MyBuyers",
              component: MyBuyers,
              meta: {
                sidRequired: true
              }
            },
            {
              path: "/:lang/profile/my-sellers",
              name: "MySellers",
              component: MySellers,
              meta: {
                sidRequired: true
              }
            },
            {
              path: "/:lang/profile/notifications",
              name: "Notifications",
              component: Notifications,
              meta: {
                sidRequired: true
              }
            },
            {
              path: "/:lang/profile/messages",
              name: "Messages",
              component: MessagesWrapper,
              meta: {
                sidRequired: true
              }
            }
          ]
        },
        {
          path: "/:lang/faq",
          name: "Faq",
          component: Faq
        },
        {
          path: "/:lang/rules",
          name: "Rules",
          component: Rules
        },
        {
          path: "/:lang/news",
          name: "News",
          component: News
        },
        {
          path: "/:lang/news-description/:id",
          name: "NewsDescriptionPage",
          component: NewsDescriptionPage
        },
        {
          path: "/:lang/newad",
          name: "NewAd",
          meta: {
            sidRequired: true
          },
          component: NewAd
        },
        {
          path: "/:lang/forgot-password",
          name: "ForgotPassword",
          component: ForgotPassword
        },
        {
          path: "/:lang/resend-verification",
          name: "Verification",
          component: Verification
        },
        {
          path: "/:lang/verification",
          name: "VerificationDisplay",
          component: VerificationDisplay
        },
        {
          path: "/:lang/unsubscribe",
          name: "Unsubscribe",
          component: Unsubscribe
        },
        {
          path: "/:lang/competition/:id",
          name: "Competition",
          component: Competition
        },
        {
          path: "/:lang/competition/:id/entry",
          name: "CompetitionEntry",
          component: CompetitionEntry
        },
        {
          path: "/:lang/competition/:id/entry-edit",
          name: "CompetitionEntryEdit",
          component: CompetitionEntryEdit
        },
        {
          path: "/:lang/competitions",
          name: "Competitions",
          component: Competitions
        },
        {
          path: "/:lang/competition-rules/:id",
          name: "CompetitionRules",
          component: CompetitionRules
        },
        {
          path: "/:lang/competition-rank-list/:id",
          name: "CompetitionRankList",
          component: CompetitionRankList
        },
        {
          path: "/:lang/competitions/missing-school-link",
          name: "CompetitionNoSchool",
          component: CompetitionNoSchool
        },
        {
          path: "/:lang/franchise",
          name: "Franchise",
          component: Franchise
        },
        {
          path: "/:lang/register",
          name: "Register",
          component: RegisterPage,
          redirect: "/:lang/register/1",
          children: [
            {
              path: "/:lang/register/1",
              name: "RegisterPage1",
              component: RegisterPage1,
              props: true
            },
            {
              path: "/:lang/register/2",
              name: "RegisterPage2",
              component: RegisterPage2,
              props: true
            },
            {
              path: "/:lang/register/3",
              name: "RegisterPage3",
              component: RegisterPage3,
              props: true
            }
          ]
        }
      ]
    },
    {
      path: "*",
      redirect: `/${i18n.locale}/not-found`
    }
  ]
});

router.afterEach((to, from) => {
  if (to.params.lang) {
    i18n.locale = to.params.lang;
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.adminRequired) {
    let dontNavAnymore = false;
    api
      .checkSession()
      .then(res => {
        store.commit("changeUserIsLoged", true);
        store.commit("setUserName", res.data.usr_name);
        store.commit("setUserImage", res.data.usr_image);
        store.commit("setDisplayName", res.data.display_name);

        if (res.data.admin && res.data.admin === true) {
          store.commit("setUserAdmin", true);
        }
        api
          .getNotificationsCount()
          .then(r => {
            store.commit("setNotificationCounters", r.data);
          })
          .catch(e => {
            console.log(e);
          });
      })
      .catch(e => {
        if (e.response.request.status === 401) {
          store.commit("changeUserIsLoged", false);
          store.commit("setUserName", null);
          store.commit("setUserImage", null);
          store.commit("setDisplayName", null);

          store.commit("setUserAdmin", false);
          dontNavAnymore = true;
          return next("/" + i18n.locale);
        }
      })
      .finally(() => {
        if (dontNavAnymore) {
          return;
        }
        if (localStorage.sid && store.state.userAdmin) {
          return next();
        } else {
          return next("/" + i18n.locale);
        }
      });
  } else if (to.meta.sidRequired) {
    let dontNavAnymore = false;
    api
      .checkSession()
      .then(res => {
        store.commit("changeUserIsLoged", true);
        store.commit("setUserName", res.data.usr_name);
        store.commit("setUserImage", res.data.usr_image);

        if (res.data.admin && res.data.admin === true) {
          store.commit("setUserAdmin", true);
        }
        api
          .getNotificationsCount()
          .then(r => {
            store.commit("setNotificationCounters", r.data);
          })
          .catch(e => {
            console.log(e);
          });
      })
      .catch(e => {
        console.log(e);
        if (e.response.request.status === 401) {
          store.commit("changeUserIsLoged", false);
          store.commit("setUserName", null);
          store.commit("setUserImage", null);
          store.commit("setUserAdmin", false);
          dontNavAnymore = true;
          return next("/" + i18n.locale);
        }
      })
      .finally(() => {
        if (dontNavAnymore) {
          return;
        }
        if (localStorage.sid && store.state.userIsLoged) {
          return next();
        } else {
          return next("/" + i18n.locale);
        }
      });
  } else {
    return next();
  }
});

export default router;
